import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { AlertService } from 'services/alert.service';
import { FriendDetailsService } from 'services/frienddetails.service';
import { NavigationService } from 'services/navigation.service';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-referfriends',
  templateUrl: './referfriends.component.html',
  styleUrls: ['./referfriends.component.scss']
})
export class ReferFriendsComponent implements OnInit {
  form: FormGroup;
  dropdownSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  accountTypeList: any;
  bankList: any[];
  branchCode: any;

  constructor(private formBuilder: FormBuilder,
    private navigationService: NavigationService,
    private alertService: AlertService,
    private friendDetailsService: FriendDetailsService,
    private router: Router,
    private route: ActivatedRoute

  ) {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'Un Select All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };


  }

  ngOnInit() {
    this.initializeValidators();
    this.getAccountType(false);
    this.getBankDetails(false);
  }

  getAccountType(refresh) {
    this.friendDetailsService.getAccountType(refresh).subscribe(result => {
      this.accountTypeList = [];
      this.accountTypeList = result;
    });
  }

  getBankDetails(refresh) {
    this.friendDetailsService.getBankDetails(refresh).subscribe(result => {
      this.bankList = [];
      this.bankList = result;
    });
  }


  // initializeValidators() {
  //   this.form = this.formBuilder.group({      
  //     firstName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],
  //     lastName: ['', [Validators.required, Validators.pattern('.*\\S.*[a-zA-z ]')]],    
  //     cellNumber: ['', [Validators.required, Validators.pattern('[0-9]*')]],
  //     email: ['', [Validators.required, Validators.email]], 
  //     accountHolderName: ['', [Validators.required]],
  //     bank: ['', [Validators.required]],
  //     branchCode: ['', [Validators.required]],
  //     accountNumber: ['', [Validators.required]],
  //     accountType: ['', [Validators.required]],
  //     });
  // }


  initializeValidators() {
    this.form = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.pattern("^[A-Za-z]+$")]],
      lastName: ['', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]],
      cellNumber: ['', [Validators.required, Validators.pattern('[0-9]*')]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  //   bankChange(event) {

  //     var bankValue = this.bankList.filter(item => {
  //      return item.name.includes(this.form.value.bank);
  //     });
  //     this.branchCode = bankValue[0].code;
  //     this.form.controls['branchCode'].setValue(this.branchCode);
  //  }

  //  accountTypeChange  (event) {

  // }




  onSubmit() {

    if (this.form.value.cellNumber) {
      if (this.form.value.cellNumber.length < 9) {
        this.alertService.warning('Please enter valid cellphone number');
        return;
      }
      else if (this.form.value.cellNumber.length == 10) {
        var mobile = this.form.value.cellNumber[0];
        if (mobile != 0) {
          this.alertService.warning('Please enter valid cellphone number');
          return;
        }
      }
    }

    if (this.form.valid) {

      this.friendDetailsService.save(this.form.value).subscribe(result => {
        if (result.isSuccess) {
          if (result.value > 0) {
            swal.fire({
              text: "Referral link has been sent successfully.",
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#d33',
              confirmButtonText: 'Ok',
            }).then((res) => {
              if (res.value) {
                // After adding a referral, navigate back to the list and request it to refresh
                this.router.navigate(['/referfriends'], { queryParams: { refresh: true } });
              }
            });

          }
        } else if (!result.isSuccess) {
          this.alertService.warning(result.htmlFormattedFailures);
        }
      });
    } else {
      this.validateFormControl();
    }
  }

  onCancel() {
    this.navigationService.goToDashboard();
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  onBack() {
    // Navigate back to the refer friends list (relative to current route)
    try {
      this.router.navigate(['../'], {
        relativeTo: this.route, queryParams: { refresh: true }
        // add refresh param 
      });
    } catch (e) {
      // fallback to absolute route
      this.router.navigate(['/referfriends'], {
        queryParams: { refresh: true }
      });
    }
  }


}
